import React from 'react'
import '../components/Header.css'


const Header = () => {
  return (
    <div className='auth'>
       <h1 className='me'>The PassCard</h1>
   
    </div>
   
       
  )
}

export default Header